export default __webpack_public_path__ + "static/media/digi.708b7b57.png";